import { HiOutlineClock } from "react-icons/hi2";
import { formatTimeAgoSpanish } from "src/helpers/formatTimeAgoSpanish";

type DepositRelativeTimeBoxProps = {
  createdAt?: string | number | Date | null;
  className?: string;
};

const DepositRelativeTimeBox = ({ createdAt, className = "" }: DepositRelativeTimeBoxProps) => {
  const relativeTime = formatTimeAgoSpanish(createdAt);

  if (!relativeTime) return null;

  return (
    <div
      className={`flex items-center gap-2 rounded-xl border border-indigo-200 bg-gradient-to-br from-indigo-50 to-violet-50 px-4 py-3 text-indigo-900 shadow-sm ${className}`}
    >
      <HiOutlineClock size={18} className="shrink-0 text-indigo-600" />
      <div>
        <div className="text-[11px] font-semibold uppercase tracking-wide text-indigo-500">
          Creada
        </div>
        <div className="text-sm font-semibold">
          {relativeTime.charAt(0).toUpperCase() + relativeTime.slice(1)}
        </div>
      </div>
    </div>
  );
};

export default DepositRelativeTimeBox;
